import React from 'react';

import {
  getAccountInfoLogo,
  ValidatorWithInfo,
} from '@block-explorer/entities';

import {
  TableData,
  TableRow,
  CircularIndicatorTextSize,
  formatPercentage,
} from '@make-software/cspr-ui';
import { BodyText } from '@block-explorer/ui';
import { Cspr, TableDataAccountInfo } from '../../../components';
import { TableDataValidatorPerformance } from '../../../components/table-data-validator-performance/table-data-validator-performance';
import styled from 'styled-components';
import { SMALL_PRECISION } from '@make-software/cspr-ui/dist/lib/utils/formatters';

const StyledTableData = styled(TableData)(({ theme }) =>
  theme.withMedia({
    paddingRight: [0, 40, 150, 0],
  })
);

interface HomeValidatorListItemProps {
  data?: ValidatorWithInfo;
  onClick?: (validatorKey: string) => void;
}

export const HomeValidatorListItem = ({ data }: HomeValidatorListItemProps) => {
  const accountInfo = data?.accountInfo;

  const logo = getAccountInfoLogo(accountInfo);
  const name = accountInfo?.info?.owner?.name;
  const validatorPerformanceScore = data?.averagePerformance?.score;

  const loading = !data;

  return (
    <TableRow>
      <TableData>
        <TableDataAccountInfo
          validatorAccount
          logo={logo}
          name={name}
          publicKey={data && data.key}
          loading={loading}
          nameSize={1}
        />
      </TableData>
      <TableData>
        <BodyText variation="darkGray" size={3} loading={loading}>
          {data &&
            formatPercentage(data.delegationFee, {
              precision: SMALL_PRECISION,
            })}
          %
        </BodyText>
      </TableData>
      <StyledTableData align="right">
        <BodyText size={3} monotype noWrap loading={loading}>
          {data && <Cspr motes={data.totalStakeAmount} />}
        </BodyText>
      </StyledTableData>
      <TableData>
        <TableDataValidatorPerformance
          performanceScore={validatorPerformanceScore}
          textSize={CircularIndicatorTextSize.small}
        />
      </TableData>
    </TableRow>
  );
};

export default HomeValidatorListItem;
